var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Alert',{staticClass:"alert-not-result",class:[{ 'text-center': _vm.center }, _vm.variant],attrs:{"id":_vm.id,"icon":_vm.icon,"variant":_vm.variant,"size":"extra-large"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }